
function updateCartNoteAttributes() {
    if (CartJS.cart.items.length) {
        let attrChanged = false;
        let attributes = CartJS.cart.attributes;
        
        const firstVisit = localStorage.getItem('riversol_first_visit') || getCookie('riversol_first_visit');
        const landingUrlAttr = sessionStorage.getItem('riversol_landing_url') || '';
        const referringUrlAttr = sessionStorage.getItem('riversol_referring_url') || '';
        const rewardOrder = CartJS.cart.items.find(item => item.properties['_redeemed'])

        if (!CartJS.cart.attributes['First Visit']) {
            attributes['First Visit'] = firstVisit;
            
        }
        if (!CartJS.cart.attributes['Order Url']) {
            attributes['Order Url'] = decodeURIComponent(landingUrlAttr);
            
        }
        if (!CartJS.cart.attributes['Referring']) {
            attributes['Referring'] = decodeURIComponent(referringUrlAttr);
            
        }

        

        return new Promise((resolve, reject) => {
            CartJS.setAttributes(attributes);
        });
    }
}

$(function () {
    addOnCampaign();
    CartJS.init(CART_JSON, {
        "rivetsModels": {
            "compare_prices": COMPARE_PRICES_JSON
        }
    });

});

function getSmileTier() {
    const smileTier = sessionStorage.getItem('smileTier') || Smile?.customer?.vip_tier_id;
    const vip_tier = smileTier;

    let tier;
    if (vip_tier == "14543") {
      tier = "Gold";
    } else if (vip_tier == "14542") {
      tier = "Silver";
    } else {
      tier = "Bronze";
    }

    if(tier)
        sessionStorage.setItem('smileTier', vip_tier);

    return tier;
}

function loadingController(state) {
    switch(state) {
        case 'on':
            $('.loading-ring').removeClass('d-none');
            $('input[name="checkout"]').prop('disabled', true)
            break;
        case 'off':
            $('.loading-ring').addClass('d-none');
            $('input[name="checkout"]').prop('disabled', false)
            break;
    }
    
}


function updateCart() {
    fetch(window.Shopify.routes.root + 'cart/update.js')
        .then(response => response.json())
        .then(data => { return data });
}


function moveMotivationBar (width) {
    const tier1 = ((width - 0) / (MOTIVATION_BAR_TIER1 - 0)) * 100;
    const tier2 = ((width - MOTIVATION_BAR_TIER1) / (MOTIVATION_BAR_TIER2 - MOTIVATION_BAR_TIER1)) * 100;
    const tier3 = ((width - MOTIVATION_BAR_TIER2) / (MOTIVATION_BAR_TIER3 - MOTIVATION_BAR_TIER2)) * 100;

    $(".motivation-bar-tier1").css('width', `${tier1}%`);
    $(".motivation-bar-tier2").css('width', `${tier2}%`);
    $(".motivation-bar-tier3").css('width', `${tier3}%`);
}

var numItems = [];
var titles = [];
var productIds = [];
var concerns = [];
var categories = [];
var prices = [];
var skin_type = [];

// Requires a segment to add a free product to the cart
// Pass TRUE is you want to avoid this conditions
const promoSegment = sessionStorage.getItem('freePromoSegment');
let addToCartError = false;
let cartRequestCompleted = true;

const freeGiftByProductPromo = !!(FREEPROMO_EVENT_BYPRODUCT && FREEPROMO_SELECTED_PRODUCTS && FREEPROMO_SELECTED_PRODUCTS.length)

//Rivets and CartJS
rivets.formatters.idx = (arr, index) => [arr[index]];
rivets.formatters.bool = (val) => !!parseInt(val);
rivets.formatters.moneyFormat = (value, currency) => {
    try {
        value.toString();
    } catch(e) {
        return '';
    }
    if (value % 100 > 0) {
        return (value > 0) ? SHOP_MONEY_WITH_CURRENCY_FORMAT_STRING.replace(/{.*}/, (value / 100).toFixed(2)) : SHOP_MONEY_WITH_CURRENCY_FORMAT_STRING.replace(/{.*}/, value.toString());
    }
    return (value > 0) ? SHOP_MONEY_WITH_CURRENCY_FORMAT_STRING.replace(/{.*}/, (value / 100).toString()) : SHOP_MONEY_WITH_CURRENCY_FORMAT_STRING.replace(/{.*}/, value.toString());
    // return (value > 0) ? SHOP_MONEY_WITH_CURRENCY_FORMAT_STRING.replace(/{.*}/, value.toString().slice(0, -2)) : SHOP_MONEY_WITH_CURRENCY_FORMAT_STRING.replace(/{.*}/, value.toString());
}
rivets.formatters.moneyFormatNoCurrency = (value) => {
    try {
        value.toString();
    } catch(e) {
        return '';
    }
    if (value % 100 > 0) {
        return (value > 0) ? SHOP_MONEY_WITHOUT_CURRENCY_FORMAT_STRING.replace(/{.*}/, (value / 100).toFixed(2)) : SHOP_MONEY_WITH_CURRENCY_FORMAT_STRING.replace(/{.*}/, value.toString());
    }
    return (value > 0) ? SHOP_MONEY_WITHOUT_CURRENCY_FORMAT_STRING.replace(/{.*}/, (value / 100).toString()) : SHOP_MONEY_WITH_CURRENCY_FORMAT_STRING.replace(/{.*}/, value.toString());
    // return (value > 0) ? SHOP_MONEY_WITHOUT_CURRENCY_FORMAT_STRING.replace(/{.*}/, value.toString().slice(0, -2)) : SHOP_MONEY_WITH_CURRENCY_FORMAT_STRING.replace(/{.*}/, value.toString());
}
rivets.binders.removeaddon = function (e, value) {
    $(e).on('click', function () {
        sessionStorage.setItem('no_free_add-on', true);
        COMPARE_PRICES_JSON.splice((value - 1), 1);
        CartJS.removeItem(value);
    })
}
rivets.binders.removecompare = function (e, value) {
    $(e).on('click', function () {
        COMPARE_PRICES_JSON.splice((value - 1), 1);
    })
}
rivets.binders.limit = function (e, value) {
    if (!isNaN(value)) {
        $(e).toggle(value > 0);
    }
}

rivets.formatters.replacePercentage = (value) => {
    return value.replace(' Percent', '%');
}
rivets.formatters.replaceTitle = (value) => {
    return value.replace(' Percent', '%').replace(' (P)', '');
}

rivets.formatters.variantRender = (value) => {
    if (value) {
        // console.log(value);
        var newVal = value.split('/ ')[0]
        if (newVal.match(/Oily|Dry|Comb/)) {
            return "For " + newVal + " Skin";
        } else {
            if (newVal.includes("Default Title")) return "";
            return newVal;
        }
    }
}
rivets.formatters.variantTintRender = (value) => {
    if (value) {
        // console.log('variantTintRender');
        // console.log(value);
        var newVal = value.split('/ ')[2] || '';
        if (newVal.match(/UNTINTED|SHADE 100|SHADE 200/)) {
            return "" + newVal + " SPF";
        } else {
            if (newVal.includes("Default Title")) return "";
            return "";
        }
    }
}

// BUNDLER Formatters
var BUNDLER_ITEMS = [];
rivets.formatters.buildabundleitems = (value) => {
    const items = value.filter(x => isBuildABundle(x.id));
    return items;
};
rivets.formatters.notbuildabundleitems = (value) => {
    const items = value.filter(x => !isBuildABundle(x.id));
    return items;
};
rivets.formatters.bundlerItems = (value) => {
    const items = value.filter(x => isBundlerItem(x.id));
    const separatedItems = [[]];
    for (let i = 0; i < items.length; i++) {
        const element = items[i];
        if (element.quantity == 1) {
            separatedItems[0].push(element);
        } else {
            for (let j = 0; j < element.quantity; j++) {
                const temp = {
                    ...element,
                    quantity: 1,
                };
                if (separatedItems[j]) {
                    separatedItems[j].push(temp);
                } else {
                    separatedItems.push([temp]);
                }
            }
        }
    }
    BUNDLER_ITEMS = separatedItems.flat(1);
    return BUNDLER_ITEMS;
};
function isBundlerItem(variantId) { // hardcoded for now
    switch (variantId) {
        case 40138306584623: // aa - full hydrating cleanser
        case 40138330472495:
        case 40138327490607:
        case 40138334863407:
        case 40138371530799:
        case 40138411966511:
        case 40138401415215:
        case 40138407739439:
        case 40138420322351:
        case 40138426777647:
        case 40138432249903:
        case 40138437034031:
        case 40138442735663:
        case 40138452336687: // aa - travel daily moisturizer
        case 40178013339695: // rc - full hydrating cleanser
        case 40178013372463:
        case 40178013405231:
        case 40178013437999:
        case 40178013470767:
        case 40178013503535:
        case 40178013536303:
        case 40178013569071:
        case 40178013601839:
        case 40178013634607:
        case 40178013667375:
        case 40178013700143:
        case 40178013732911:
        case 40178013765679: // rc - travel daily moisturizer
            return true;
        default:
            return false;
    }
}
rivets.formatters.bundlerGroups = (value) => {
    const numGroups = value.length / 6;
    const items = [];
    for (let index = 0; index < numGroups; index++) {
        items.push({ ...value[(index) * 6], bundlegroupindex: index })
    }
    return items;
};
rivets.formatters.bundlerGroup = (value, index) => {
    return bundlerGroup(value, index);
};
function bundlerGroup(value, index) {
    var min = (index) * 6;
    var max = (index + 1) * 6;
    if (min < 0) min = 0;
    if (max > value.length) max = value.length;
    return value.slice(min, max);
}
rivets.formatters.totalPrice = (value) => {
    var price = 0;
    value.map(x => x.original_price).forEach(p => {
        price += p * 1;
    });
    return price;
}
rivets.formatters.totalCompare = (value) => {
    var price = 0;
    value.forEach(p => {
        price += p * 1;
    });
    return [price];
}



// BUNDLER binders
rivets.binders.removebundler = function (e, value) {
    $(e).on('click', function () {
        const removeIds = bundlerGroup(BUNDLER_ITEMS, value - 1).map(x => x.id);
        const allIdCounts = {}; // {12345678: 6, 12345680: 1}
        BUNDLER_ITEMS.map(x => x.id).forEach(id => {
            if (allIdCounts[id]) {
                allIdCounts[id] += 1;
            } else {
                allIdCounts[id] = 1;
            }
        });
        const update = {}; // {12345678: 5, 12345680: 0}
        removeIds.forEach(r => {
            update[r] = (allIdCounts[r] || 1) - 1;
        });
        CartJS.updateItemQuantitiesById(update);
    })
}
rivets.binders.isbundler = function (e, value) {
    if (isBundlerItem(value)) {
        $(e).show();
    } else {
        $(e).hide();
    }
}
rivets.binders.notbundler = function (e, value) {
    if (!isBundlerItem(value)) {
        $(e).show();
    } else {
        $(e).hide();
    }
}
rivets.binders.aahide = function (e, value) {
    if (value == "6778147700783") { // aa build-your-bundle product_id
        $(e).show();
    } else {
        $(e).hide();
    }
}
rivets.binders.rchide = function (e, value) {
    if (value == "6785009516591") { // rc build-your-bundle product_id
        $(e).show();
    } else {
        $(e).hide();
    }
}

rivets.binders.issubscription = function (e, value) {
    if (value) {
        if (value.selling_plan_allocation) {
            $(e).show();
            return;
        }
    }
    $(e).hide();
}
rivets.binders.subscriptionclass = function (e, value) {
    if (value) {
        if (value.selling_plan_allocation) {
            if (!$(e).hasClass('subscription')) $(e).addClass('subscription');
            return;
        }
    }
    $(e).removeClass('subscription');
}

rivets.formatters.subscriptionlabelRender = (value) => {
    if (value) {
        if (value.selling_plan_allocation) {
            console.log(value);
            if (value.handle.includes("retinol-neck-cream")) {
                return 'REFILLS ' + value.selling_plan_allocation.selling_plan.name;
            }
            return value.selling_plan_allocation.selling_plan.name;
        }
        return null;
    }
}

// Motivation Bar Tiers
rivets.binders.motbartier = (e, value) => {
    const tier = $(e).data('tier');

    let tierValue = 0
    switch(tier) {
        case 'tier1':
            tierValue = MOTIVATION_BAR_TIER1 * 100
            break;
        case 'tier2':
            tierValue = MOTIVATION_BAR_TIER2 * 100
            break;
        case 'tier3':
            tierValue = MOTIVATION_BAR_TIER3 * 100
            break;
    }

    $(e).text(`$${(tierValue - parseInt(value)) / 100}`);
    
}

rivets.binders.divided = (e, value) => {
    const dividedBy = parseInt($(e).data('dividedby'));
    const afterpay = parseInt($(e).data('afterpay'));
    const vd102more = CartJS.cart.items.find(i => i.properties['_vd_10_2more']);
    const reward = CartJS.cart.items.find(i => i.properties['_redeemed']);
    let newValue = afterpay && reward ? value - reward.line_level_total_discount : value;
    newValue = afterpay && vd102more ? newValue - vd102more.line_level_total_discount : newValue;
    $(e).text((parseInt(newValue) / dividedBy) / 100);
}


/* fix only 1 label printing */
function variantpreorder(e, value, idx) {
    let list = PRE_ORDER_VARIANTS;
    let splitted = list.replaceAll(' ', '').split(',');
    if (splitted.length >= (idx + 1)) {
        splitted = [splitted[idx]];
    } else {
        splitted = [];
    }
    if (splitted.includes(value + '')) {
        $(e).show();
        $(e).removeClass('no-preorder');
    } else {
        $(e).hide();
        if ($(e).hasClass('no-preorder')) $(e).addClass('no-preorder');
    }
}
rivets.binders.showvariantpreorder = function (e, value) {
    // console.log("showvariantpreorder: " + value);
    variantpreorder(e, value, 0);
}
rivets.binders.showvariantpreorder2 = function (e, value) {
    variantpreorder(e, value, 1);
}
rivets.binders.showvariantpreorder3 = function (e, value) {
    variantpreorder(e, value, 2);
}

rivets.binders.showpreorder = function (e, value) {
    // console.log("showpreorder: " + value);
    if (value == PRE_ORDER_ID) {
        $(e).show();
        $(e).removeClass('no-preorder');
    } else {
        $(e).hide();
        if ($(e).hasClass('no-preorder')) $(e).addClass('no-preorder');
    }
}
rivets.binders.showsecondarypreorder = function (e, value) {
    // console.log("showsecondarypreorder: " + value);
    // SECONDARY_PRE_ORDER_ID = "40865829945391|40865829912623|40865829879855"
    if ((SECONDARY_PRE_ORDER_ID + '').split('|').includes(value + '')) {
        $(e).show();
        $(e).removeClass('no-preorder');
    } else {
        $(e).hide();
        if ($(e).hasClass('no-preorder')) $(e).addClass('no-preorder');
    }
}

/* BUILD-A-BUNDLE */
rivets.binders.showmoisturizerselect = function (e, value) {
    // console.log("showmoisturizerselect: " + value.handle.includes('free-moisturizer'));
    if (value.handle.includes('free-moisturizer')) {
        $(e).show();
    } else {
        $(e).hide();
    }
}
rivets.binders.hidemoisturizerselect = function (e, value) {
    // console.log("hidemoisturizerselect: " + value.tags);
    if (value.handle.includes('free-moisturizer')) {
        $(e).hide();
    } else {
        $(e).show();
    }
}
rivets.formatters.variantRenderMoisturizerSelect = (value) => {
    if (value) {
        // console.log(value);
        var newVal = value.split('/ ')[0];
        if (newVal.match(/Oily|Dry|Comb/)) {
            switch(newVal.trim()) {
                case 'Normal to Dry':
                    return 'Daily Moisturizing Cream';
                case 'Oily':
                    return 'Lightweight Moisturizing Lotion';
                case 'Very Dry':
                    return 'Moisturizing Concentrate';
            }
            return newVal;
        } else {
            if (newVal.includes("Default Title")) return "";
            return newVal;
        }
    }
}

rivets.binders.dotdshow = function (e, value) {
    if (isdotd(value)) {
        $(e).show();
    } else {
        $(e).hide();
    }
}
function isdotd(value) { 
    console.log(value)
    for(i=0;i<value.length;i++) {
        let item=value[i];
        if (dotdproducts.includes(item.handle)) return true;
    }
    return false;
}
rivets.binders.dotdhide = function (e, value) {
    if (!isdotd(value)) {
        $(e).show();
    } else {
        $(e).hide();
    }
}
rivets.binders.isbuildabundle = function (e, value) {
    if (isBuildABundle(value)) {
        $(e).show();
        $(e).removeClass('dont-submit');
    } else {
        $(e).hide();
        if ($(e).hasClass('dont-submit')) $(e).addClass('dont-submit');
    }
}
rivets.binders.notbuildabundle = function (e, value) {
    if (!isBuildABundle(value)) {
        $(e).show();
        $(e).removeClass('dont-submit');
    } else {
        $(e).hide();
        if ($(e).hasClass('dont-submit')) $(e).addClass('dont-submit');
    }
}
function isBuildABundle(variantId) { // hardcoded for now (from product: 6790312067119)
    switch (variantId) {
        case 40206892597295: // aa - full hydrating cleanser
        case 40206940700719:
        case 40206892630063:
        case 40206943256623:
        case 40206892662831:
        case 40206945026095:
        case 40206892695599:
        case 40206946271279:
        case 40206988017711:
        case 40206988050479:
        case 40206988509231:
        case 40206988541999:
            return true;
        default:
            return false;
    }
}
rivets.formatters.variantrenderbuildabundle = (value) => {
    if (value) {
        switch (value) {
            case 40206892597295:
                return "Hydrating Cream Cleanser, Anti-Aging Serum, Daily Moisturizing Cream + 3 Free Travel Sizes";
            case 40206940700719:
                return "Hydrating Cream Cleanser, Anti-Redness Serum, Daily Moisturizing Cream + 3 Free Travel Sizes";
            case 40206892630063:
                return "Refreshing Gel Cleanser, Anti-Aging Serum, Daily Moisturizing Cream + 3 Free Travel Sizes";
            case 40206943256623:
                return "Refreshing Gel Cleanser, Anti-Redness Serum, Daily Moisturizing Cream + 3 Free Travel Sizes";
            case 40206892662831:
                return "Hydrating Cream Cleanser, Anti-Aging Serum, Moisturizing Concentrate + 3 Free Travel Sizes";
            case 40206945026095:
                return "Hydrating Cream Cleanser, Anti-Redness Serum, Moisturizing Concentrate + 3 Free Travel Sizes";
            case 40206892695599:
                return "Refreshing Gel Cleanser, Anti-Aging Serum, Lightweight Lotion + 3 Free Travel Sizes";
            case 40206946271279:
                return "Refreshing Gel Cleanser, Anti-Redness Serum, Lightweight Lotion + 3 Free Travel Sizes";
            case 40206988017711:
                return "Refreshing Gel Cleanser, Anti-Aging Serum, Moisturizing Concentrate + 3 Free Travel Sizes";
            case 40206988050479:
                return "Refreshing Gel Cleanser, Anti-Redness Serum, Moisturizing Concentrate + 3 Free Travel Sizes";
            case 40206988509231:
                return "Hydrating Cream Cleanser, Anti-Aging Serum, Lightweight Lotion + 3 Free Travel Sizes";
            case 40206988541999:
                return "Hydrating Cream Cleanser, Anti-Redness Serum, Lightweight Lotion + 3 Free Travel Sizes";
            default:
                return "";
        }
    }
}

rivets.binders.checkdiscount = function (e, value) {
    const originalPrice = $(e).text();
    const currentPrice = value;
    const noDiscount = originalPrice === currentPrice;
    noDiscount && $(e).remove();
}


async function swapSampleKit () {
    let sampleMap;

    // Check if the cart has more than one item
    const cartItems = CartJS.cart.items;

    // Mapped SKUs to get swapped 
    // [{REGULAR SAMPLE SKU}, {INBOX SAMPLE VARIANT ID}]
    if(cartItems.length <= 1)  { 
        let usCart;
        if (Geolizr) {
            usCart = await new Promise((resolve, reject) => {
                Geolizr.getGeoData((gl) => {
                    resolve(gl.countryCode !== 'CA')
                })
            });
        }
        if(usCart) {
            // sampleMap = [
            //     ['2SA010AAN', US_AASAMPLE.variants.filter(v => v.sku === '2SA036AAN').map(v => v.id)[0]],
            //     ['2SA010AAC', US_AASAMPLE.variants.filter(v => v.sku === '2SA036AAC').map(v => v.id)[0]],
            //     ['2SA010AAV', US_AASAMPLE.variants.filter(v => v.sku === '2SA036AAV').map(v => v.id)[0]],
            //     ['2SA010AAO', US_AASAMPLE.variants.filter(v => v.sku === '2SA036AAO').map(v => v.id)[0]],
            //     ['2SA011RCN', US_RCSAMPLE.variants.filter(v => v.sku === '2SA037RCN').map(v => v.id)[0]],
            //     ['2SA011RCC', US_RCSAMPLE.variants.filter(v => v.sku === '2SA037RCC').map(v => v.id)[0]],
            //     ['2SA011RCV', US_RCSAMPLE.variants.filter(v => v.sku === '2SA037RCV').map(v => v.id)[0]],
            //     ['2SA011RCO', US_RCSAMPLE.variants.filter(v => v.sku === '2SA037RCO').map(v => v.id)[0]]
            // ]
          return
        }
        else { return }
    } else {
        sampleMap = [
            ['2SA010AAN', INBOX_AASAMPLE.variants.filter(v => v.sku === '2SA034001').map(v => v.id)[0]],
            ['2SA010AAC', INBOX_AASAMPLE.variants.filter(v => v.sku === '2SA034002').map(v => v.id)[0]],
            ['2SA010AAV', INBOX_AASAMPLE.variants.filter(v => v.sku === '2SA034003').map(v => v.id)[0]],
            ['2SA010AAO', INBOX_AASAMPLE.variants.filter(v => v.sku === '2SA034004').map(v => v.id)[0]],
            ['2SA011RCN', INBOX_RCSAMPLE.variants.filter(v => v.sku === '2SA035001').map(v => v.id)[0]],
            ['2SA011RCC', INBOX_RCSAMPLE.variants.filter(v => v.sku === '2SA035002').map(v => v.id)[0]],
            ['2SA011RCV', INBOX_RCSAMPLE.variants.filter(v => v.sku === '2SA035003').map(v => v.id)[0]],
            ['2SA011RCO', INBOX_RCSAMPLE.variants.filter(v => v.sku === '2SA035004').map(v => v.id)[0]],
            // ['2SA036AAN', INBOX_AASAMPLE.variants.filter(v => v.sku === '2SA034001').map(v => v.id)[0]],
            // ['2SA036AAC', INBOX_AASAMPLE.variants.filter(v => v.sku === '2SA034002').map(v => v.id)[0]],
            // ['2SA036AAV', INBOX_AASAMPLE.variants.filter(v => v.sku === '2SA034003').map(v => v.id)[0]],
            // ['2SA036AAO', INBOX_AASAMPLE.variants.filter(v => v.sku === '2SA034004').map(v => v.id)[0]],
            // ['2SA037RCN', INBOX_RCSAMPLE.variants.filter(v => v.sku === '2SA035001').map(v => v.id)[0]],
            // ['2SA037RCC', INBOX_RCSAMPLE.variants.filter(v => v.sku === '2SA035002').map(v => v.id)[0]],
            // ['2SA037RCV', INBOX_RCSAMPLE.variants.filter(v => v.sku === '2SA035003').map(v => v.id)[0]],
            // ['2SA037RCO', INBOX_RCSAMPLE.variants.filter(v => v.sku === '2SA035004').map(v => v.id)[0]],
            ['2SA026ERT', INBOX_PRSAMPLE.variants.filter(v => v.sku === '2SA126ERT').map(v => v.id)[0]],
            ['2SA027CV2', INBOX_PRSAMPLE.variants.filter(v => v.sku === '2SA127CV2').map(v => v.id)[0]],
            ['2SA028RTT', INBOX_PRSAMPLE.variants.filter(v => v.sku === '2SA128RTT').map(v => v.id)[0]],
            ['2SA029RCM', INBOX_PRSAMPLE.variants.filter(v => v.sku === '2SA129RCM').map(v => v.id)[0]],
            ['2SA030HBM', INBOX_PRSAMPLE.variants.filter(v => v.sku === '2SA130HBM').map(v => v.id)[0]],
            ['2SA031EGP', INBOX_PRSAMPLE.variants.filter(v => v.sku === '2SA131EGP').map(v => v.id)[0]],
            ['2SA032SPF', INBOX_PRSAMPLE.variants.filter(v => v.sku === '2SA132SPF').map(v => v.id)[0]],
            
        ]
    }

    const cartItemsMap = cartItems.map((item, idx) => ({
        sku: item.sku,
        id: item.id,
        productId: item.product_id,
        index: idx + 1
    }));

    // Check if the cart has samples to be swapped
    const sampleItems = cartItemsMap.filter(variant => sampleMap.find(mappedSKU => mappedSKU.indexOf(variant.sku) > -1) );    
    if(sampleItems.length) {

        //IGNORE PAID SAMPLES
        const paidSampleItem = sampleItems.find(i => PAID_SAMPLE_PRODUCTS.find(paid => paid.id === i.productId));
        if(paidSampleItem) {
            console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>> Sample (P)');
            return;
        }

        sampleItems.forEach(variant => {
            const itemMap = sampleMap.find(mappedSKU => mappedSKU.indexOf(variant.sku) > -1)

            // REMOVE ITEM
            console.log('REMOVE', variant.id)
            CartJS.removeItem(variant.index, {
                "success": (data, textStatus, jqXHR) => {
                    // ADD ITEM
                    console.log('ADD', itemMap, itemMap[3])
                    CartJS.addItem(itemMap[1], 1, {})
                },
                "error": function (jqXHR, textStatus, errorThrown) {
                    console.log('CartJS Error.');
                }
            });

            
        }) 
    }
    

}

async function clearCartCheck() {

    const cartItems = CartJS.cart.items;

    if(cartItems.length === 1) {
        const inboxSKUs = ['2SA034001','2SA034002','2SA034003','2SA034004','2SA035001','2SA035002','2SA035003','2SA035004']
        const inboxSKU = inboxSKUs.find(ibsku => ibsku.indexOf(cartItems[0].sku || null) > -1);
        const freeProduct = cartItems.find(item => item.properties['_freePromoSelect']);
        if(inboxSKU || freeProduct){
            CartJS.updateItemById(cartItems[0].key, 0, {
                "success": function (data, textStatus, jqXHR) {
                    $('.loading-ring').addClass('d-none');
                },
                "error": function(jqXHR, textStatus, errorThrown) {
                    $('.loading-ring').addClass('d-none');
                }
            });
        }
    }

    checkRewardItem();

}

function checkRewardItem () {
    const cartItems = CartJS.cart.items;
    const hasRewardItem = cartItems.find(item => item.properties['_redeemed']);
    if(!CUSTOMER) {
        if(hasRewardItem) {
            $('.loading-ring').removeClass('d-none');
            CartJS.updateItemById(hasRewardItem.key, 0, {
                "success": function (data, textStatus, jqXHR) {
                    $('.loading-ring').addClass('d-none');
                },
                "error": function(jqXHR, textStatus, errorThrown) {
                    $('.loading-ring').addClass('d-none');
                }
            });
        }
    }

    // CLEAR REWARD ATTRIBUTES
    // if(!hasRewardItem) {
    //     if(CartJS.cart.attributes['Reward Points']) {
    //         let attributes = CartJS.cart.attributes || {};
    //         if (attributes.hasOwnProperty('Reward Points')) {
    //             delete attributes['Reward Points'];
    //             delete attributes['Reward Product'];
    //         }
    //     }
    // }
}

function FreeProductPromoClass () {
    
    this.initPromoEvent = initPromoEvent;
    this.selectionAdd = selectionAdd;
    this.selectionUpdate = selectionUpdate;
    this.selectionChange = selectionChange;
    this.eventCartCheck = eventCartCheck;
    this.getMinTotal = getMinTotal;
    this.removePromoItems = removePromoItems;
    this.addPromoItem = addPromoItem;
    this.swapPromoItem = swapPromoItem;

    async function initPromoEvent() {
        console.log('- INIT PROMO EVENT')
        if(!(FREEPROMO_PRODUCTS && FREEPROMO_PRODUCTS.length)) return

        loadingController('on');
        freeProductPromo.selectionAdd();
        freeProductPromo.eventCartCheck();
    }

    async function selectionAdd() {
        console.log(' --- CHECK ADD PRODUCT ')
        
        const cartItems = CartJS.cart.items;
        const cartTotal = CartJS.cart.total_price / 100;
        const allVariants = FREEPROMO_PRODUCTS.map(product => {
            product.variants.forEach(v => v.tags = product.tags);
            return product.variants
        }).reduce((a,b) => a.concat(b));

        if(cartTotal < this.getMinTotal()) {
            await this.removePromoItems();
            console.log(' === Cart does not have the minimum amount required');
            return
        }

        if(!cartItems.length) {
            console.log(' === Cart is empty');
            return
        }
            
        // Validate if the free promo product is already include in the cart
        if(cartItems.filter(item => item.properties._freePromoSelect).length) {
            loadingController('off');
            console.log(' === Free product is already included in the cart');
            if(FREEPROMO_PRODUCTS.length > 1 ) {
                $('.freeProductSelect-wrapper').removeClass('d-none');
            } 
            return 
        }
        
        // Take the first product in the list to add - Except if it's a segmented event
        const freeProductVariantToAdd = FREEPROMO_EVENT_SEGMENTED 
                                    ? allVariants.filter(variant => variant.tags.join().indexOf(promoSegment) > -1)[0]
                                    : allVariants[0];

        
        // Skip if "addItem" got error (check error description in the console)
        if(addToCartError) {
            loadingController('off');
            console.log(' === Error adding Free product to Cart');
            return false
        } 
            
        // For "Gift by Product" promo, check if the product in the cart
        if (freeGiftByProductPromo) {
            const productInCart = cartItems.find(item => FREEPROMO_SELECTED_PRODUCTS.find(p => p.id === item.product_id))
            if(!productInCart) {
                loadingController('off');
                console.log(' === (Gift by Product) Free product is already included in the cart');
                return;
            }
        }
   
        // Add Promo item to cart
        if(freeProductVariantToAdd) {
            await this.addPromoItem(freeProductVariantToAdd.id);
        };
        
        return;
    }
    
    async function selectionUpdate() {
        console.log(' --- CHECK UPDATE PRODUCT ')
        const cartItems = CartJS.cart.items;
        const cartTotal = CartJS.cart.total_price / 100;
        

        // Check if cart total matches the minimum amount
        if(cartTotal < this.getMinTotal()) {
            await this.removePromoItems();
            console.log(' === Cart does not have the minimum amount required');
            return
        } else {

            // Check if "Segmented" promo is enabled/valid
            if(FREEPROMO_EVENT_SEGMENTED && !promoSegment) {
                await this.removePromoItems();
                console.log(' === Segmented Promo is not enabled/valid');
                return
            }

            // Check if "Gift by Product" Promo is enabled/valid
            if (freeGiftByProductPromo) {
                const productInCart = cartItems.find(item => FREEPROMO_SELECTED_PRODUCTS.find(p => p.id === item.product_id))
                if(!productInCart) {
                    await this.removePromoItems();
                    console.log(' === (Gift by Product) Free product is already included in the cart');
                    return
                }
            }

            if(!cartItems.length) {
                console.log(' === Cart is empty');
                return
            }

            // Check if there are items to be added to cart
            freeProductPromo.selectionAdd();
        }

    }
    
    async function selectionChange(e) {
        console.log(' --- CHANGING PRODUCT ')
        const product = $(e).data('variant-id');
        
        $('#modal-miniselect').modal('hide');
    
        // await this.removePromoItems().catch(e => console.error(e));
        // await this.addPromoItem(product);
        const cartItems = CartJS.cart.items;
        const removeItem = cartItems && cartItems.find(item => item.properties['_freePromoSelect']);
        await this.swapPromoItem(removeItem.variant_id, product)
    }
    
    function eventCartCheck() {
        console.log(' --- EVENT CHECK CART ')

        const cartItems = CartJS.cart.items;
        const cartTotal = CartJS.cart.total_price / 100;
        // SUCCESS MESSAGE
        if((promoSegment && (FREEPROMO_EVENT || FREEPROMO_EVENT_SEGMENTED || freeGiftByProductPromo || FREEPROMO_EVENT_TIERED)) && cartTotal > this.getMinTotal()) {
            $('.cart-hero-wrapper-content *').hide();
            $('.cart-hero-wrapper-content').append(`
                <span class="cart-hero-wrapper-content-success">${FREEPROMO_EVENT_SUCCESS_MSG}</span>
            `)
        }
        else {
            $('.cart-hero-wrapper-content *').show();
            $('.cart-hero-wrapper-content-success').remove();
        }

        // Display segment products only
        if(promoSegment) {
            document.querySelectorAll(`.freepromo-${promoSegment}`).forEach(i => { i.classList.remove('d-none') });
        } else {
            
        }
    }

    function getMinTotal() {
        let minTotal = FREEPROMO_EVENT_MIN_TOTAL;
        if(FREEPROMO_EVENT_TIERED) {
            switch(getSmileTier()) {
                case 'Bronze':
                    minTotal = FREEPROMO_EVENT_MIN_TOTAL_BRONZE;
                    break;
                case 'Silver':
                    minTotal = FREEPROMO_EVENT_MIN_TOTAL_SILVER;
                    break;
                case 'Gold':
                    minTotal = FREEPROMO_EVENT_MIN_TOTAL_GOLD;
                    break;
            }
        }
        
        return minTotal
    }
    
    async function removePromoItems() {
        console.log(' ------ REMOVING PRODUCT ');
        loadingController('on');
        
        cartRequestCompleted = false;
        const cartItems = CartJS.cart.items;
        const removeItem = cartItems && cartItems.find(item => item.properties['_freePromoSelect']);

        if(removeItem) {
                // TODO: FIX "COMPARE PRICE" WHEN REMOVING FREEPROMO ITEM
                //       COMPARE_PRICES_JSON.shift();

                return new Promise((resolve, reject) => {
                    CartJS.removeItemById(removeItem.variant_id, {
                        "success": function (data, textStatus, jqXHR) {
                            cartRequestCompleted = true;
                            console.log(' === Free Product REMOVED with success to the cart');
                            loadingController('off');
                            resolve(data);
                        },
                        "error": function(jqXHR, textStatus, errorThrown) {
                            cartRequestCompleted = true;
                            loadingController('off');
                            reject(textStatus)
                        }
                    });
                })
        } else {
            cartRequestCompleted = true;
            loadingController('off');
        }
    }

    async function addPromoItem(productVariantId) {
        console.log(' ------ ADDING PRODUCT ')
        cartRequestCompleted = false;
        loadingController('on');

        return new Promise((resolve, reject) => {
            CartJS.addItem(productVariantId, 1, { "_freePromoSelect": true }, {
                "success": function(data, textStatus, jqXHR) {
                    console.log(' === Free Product ADDED with success to the cart');
                    if(FREEPROMO_PRODUCTS.length > 1 ) {
                        setTimeout(() => {
                            $('.freeProductSelect-wrapper').removeClass('d-none');
                        }, 2000)
                    }    
                    cartRequestCompleted = true;
                    loadingController('off');
                    resolve(data);
                },
                "error": function(jqXHR, textStatus, errorThrown) {
                    jqXHR.responseJSON && console.log(`CartJS.addItem() Error: ${jqXHR.responseJSON.description}`)
                    addToCartError = true;
                    cartRequestCompleted = true;
                    loadingController('off');
                    reject(addToCartError);
                }
            });
        });
    }

    async function swapPromoItem(removeId, addId) {
        console.log(' ------ SWAP PRODUCT ')
        cartRequestCompleted = false;
        loadingController('on');

        return new Promise((resolve, reject) => {
            CartJS.removeItemById(removeId, {
                "success": function (data, textStatus, jqXHR) {
                    console.log(' === (Swap) Free Product REMOVED');
                    CartJS.addItem(addId, 1, { "_freePromoSelect": true }, {
                        "success": function(data, textStatus, jqXHR) {
                            console.log(' === (Swap) Free Product ADDED'); 
                            cartRequestCompleted = true;
                            loadingController('off');
                            resolve(data);
                        },
                        "error": function(jqXHR, textStatus, errorThrown) {
                            jqXHR.responseJSON && console.log(`CartJS.addItem() Error: ${jqXHR.responseJSON.description}`)
                            addToCartError = true;
                            cartRequestCompleted = true;
                            loadingController('off');
                            reject(addToCartError);
                        }
                    });
                },
                "error": function(jqXHR, textStatus, errorThrown) {
                    cartRequestCompleted = true;
                    loadingController('off');
                    reject(textStatus)
                }
            });
        })
    }

}

const freeProductPromo = new FreeProductPromoClass();

function checkVolumeDiscount() {
    const cleanList = (listToClean) => {
        if(listToClean.length) {
            listToClean.forEach(item => {
                CartJS.updateItemById(item.key, item.quantity, { "_vd_10_2more": "" });
            })
        }
    }

    const cartItems = CartJS.cart.items.map((item, index) => ({
        ...item,
        cartIndex: index + 1 
    }));
    
    const vd_10_2more = VD_10_2MORE_PRODUCTS.map(product => product.id);
    if(vd_10_2more.length) {
        const itemsToUpdate = cartItems.filter(item => item.product_type != 'Free Product')
                                        .filter(item => !item.properties['_redeemed'])
                                        .filter(item => vd_10_2more.indexOf(item.product_id) > -1);
        if(itemsToUpdate.length) {
            itemsToUpdate.forEach(item => {
                CartJS.updateItemById(item.key, item.quantity, { "_vd_10_2more": true });
            })
        }
        
        // CLEAN THE CACHE FOR THE ONES NOT ACTIVATED
        const itemsToUpdateIds = itemsToUpdate.map(product => product.product_id);
        cleanList(cartItems.filter(item => itemsToUpdateIds.indexOf(item.product_id) === -1).filter(item => item.properties['_vd_10_2more']))

    } else {
        // CLEAN THE CACHE FOR THE ONES NOT ACTIVATED
        cleanList(cartItems.filter(item => item.properties['_vd_10_2more']))
    }
}


function validateAfterPayWording() {

    // afterpay messaging validation
    if(afterpay_dynamic_cart_integration_enabled) {
        const hasSubscription = CartJS.cart.items.find(i => i.selling_plan_allocation);
        if(!hasSubscription) {
            document.querySelectorAll('.afterpay-messaging-cart').forEach(e => e.classList.remove('d-none'));
        }
    }

}



$(document).on('cart.ready', function (event, cart) {
    $('.visible-upon-load').removeClass('hidden');

    updateCartNoteAttributes();
    validateAfterPayWording();
    clearCartCheck();
    swapSampleKit();
    checkVolumeDiscount();

    console.log(' - CART READY') ;
    if(FREEPROMO_EVENT || (FREEPROMO_EVENT_SEGMENTED && promoSegment) || freeGiftByProductPromo || FREEPROMO_EVENT_TIERED) {
        if(FREEPROMO_EVENT_TIERED) {
            loadingController('on');
            let attempt = 1;
            const checkSmileLoop = function (millisec) {
                console.log('checkSmileLoop', attempt);
                if(window.hasOwnProperty('Smile') || sessionStorage.getItem('smileTier')) {
                    loadingController('off');
                    freeProductPromo.initPromoEvent();
                } else {
                    attempt ++;
                    setTimeout(() => {
                        checkSmileLoop(1000);
                    }, millisec)
                }
            }
            checkSmileLoop(1000);
        }
        else {
            freeProductPromo.initPromoEvent();
        }
        
    }
    else {
        freeProductPromo.removePromoItems();
    }

    if(MOTIVATION_BAR) {
        moveMotivationBar(cart.original_total_price / 100);
    }
    
    
    // console.log('Cleaned Attributes ', CartJS.getAttributes());
    // history.pushState({}, "", window.location.href);
    // CartJS.clearAttributes();


    const cartItemsReversed = CartJS.cart.items.reverse();
    var typesOfSamples = 0;
    var item_count = CartJS.cart.items.length;

    function checkSamples(item, index) {

        if (item.product_type == "Free Sample" || item.product_type == "Sample") {
            typesOfSamples += 1

            if (item.quantity > 1) {
                cartindex = item_count - index;
                CartJS.updateItem(cartindex, 1);
                // console.log(item.title + " limit: 1 : line # = " + cartindex);
            }

            if (typesOfSamples > 1) {
                cartindex = item_count - index;
                // console.log(item.title + ": line # = " + cartindex);
                CartJS.removeItem(cartindex);
            }
        }
    }

    cartItemsReversed.forEach(checkSamples);
    CartJS.cart.items.reverse();

});



var preOrderRemoved = false;
var secondaryPreOrderRemoved = false;
var preOrderVariantsRemoved = false;
$(document).on('cart.requestComplete', function (event, cart) {

    validateAfterPayWording();

    clearCartCheck();

    console.log(' - CART UPDATED') ;
    if(FREEPROMO_EVENT || FREEPROMO_EVENT_SEGMENTED || freeGiftByProductPromo || FREEPROMO_EVENT_TIERED) {
        if(!cartRequestCompleted) return
        
        loadingController('on');
        setTimeout(() => {
            freeProductPromo.selectionUpdate();
            freeProductPromo.eventCartCheck();
        }, 1000)
    }

    if(MOTIVATION_BAR) {
        moveMotivationBar(cart.original_total_price / 100);
    }
    
    removeDuplicateSamples();
    addOnCampaign();
    $('.cart__number').text(CartJS.cart.item_count);

    var cartItems = CartJS.cart.items;

    numItems.length = 0;
    titles.length = 0;
    productIds.length = 0;
    concerns.length = 0;
    categories.length = 0;
    prices.length = 0;
    skin_type.length = 0;

    function checkItems(item, index) {
        if (item.properties._limit) {
            if (item.quantity > item.properties._limit) {
                cartindex = index + 1;
                CartJS.updateItem(cartindex, item.properties._limit);
                console.log(item.title + ' limit:' + item.properties._limit + ": line # = " + cartindex);
            }
        }
    }

    var preOrderQty = 0;
    var preOrderQty2 = 0;
    var preOrderVariantsQty = 0;
    for (var item of cartItems) {
        numItems.push(item.quantity);
        titles.push(item.product_title);
        productIds.push(item.product_id.toString());
        categories.push(item.product_type);
        prices.push(item.price / 100);

        var inCart = cart_skin_types.find(({ name }) => name === item.product_title);
        if (typeof inCart !== 'undefined') {
            skin_type.push(inCart.skin_type || "");
        }

        if (item.title.indexOf('Eye') !== -1) {
            concerns.push("Eye");
        } else if (item.title.indexOf('Acne') !== -1) {
            concerns.push("Acne");
        } else if (item.title.indexOf('Redness') !== -1) {
            concerns.push("Redness Control");
        } else {
            concerns.push("Anti-Aging");
        }
        if ((PRE_ORDER_VARIANTS + '').replaceAll(' ', '').split(',').includes(item.id + "")) {
            preOrderVariantsQty += item.quantity;
        }
        if ((item.id + "").indexOf(PRE_ORDER_ID) !== -1 || (SECONDARY_PRE_ORDER_ID + '').split('|').includes(item.id + "")) {
            preOrderQty = item.quantity;
        }
        if ((SECONDARY_PRE_ORDER_ID + '').split('|').includes(item.id + "")) {
            preOrderQty2 = item.quantity;
        }
    }
    if (!preOrderVariantsRemoved && (PRE_ORDER_VARIANTS != "") && preOrderVariantsQty == 0) { // 
        preOrderVariantsRemoved = true;
        $('#pre-order-cart-text').hide();
        $('.checkout__button_desktop').prop("value", "Secure Checkout");
        $('.checkout__button_mobile').prop("value", "Secure Checkout");
    }
    if (!secondaryPreOrderRemoved && (SECONDARY_PRE_ORDER_ID != "") && preOrderQty2 == 0) { // 
        secondaryPreOrderRemoved = true;
        $('#secondary-pre-order-cart-text').hide();
        $('#pre-order-cart-text').show();
    }
    if (!preOrderRemoved && (PRE_ORDER_ID != "" || SECONDARY_PRE_ORDER_ID != "") && preOrderQty == 0) { // 
        preOrderRemoved = true;
        $('#pre-order-cart-text').hide();
        $('.checkout__button').prop("value", "Secure Checkout");
    }

    cartItems.forEach(checkItems);

    // ***************************
    // OLD TAG MANAGER - GTM-K2HCMZ5

    // var gtm = window.google_tag_manager['GTM-K2HCMZ5'];
    // gtm.dataLayer.set('gtm_product_id', undefined);
    // gtm.dataLayer.set('gtm_product_category', undefined);
    // gtm.dataLayer.set('gtm_product_name', undefined);
    // gtm.dataLayer.set('gtm_product_individual_prices', undefined);
    // gtm.dataLayer.set('gtm_product_currency', undefined);
    // gtm.dataLayer.set('gtm_product_price', undefined);
    // gtm.dataLayer.set('gtm_num_items', undefined);
    // gtm.dataLayer.set('gtm_product_concern', undefined);
    // gtm.dataLayer.set('gtm_skin_type', undefined);

    window.dataLayer = window.dataLayer || [];
    var product_price = CartJS.cart.total_price / 100;
    if (product_price == undefined) {
        product_price = prices.first();
    }
    Shopify.analytics.publish('cart', {
        'gtm_product_id': productIds,
        'gtm_product_category': categories,
        'gtm_product_name': titles,
        'gtm_product_price': product_price,
        'gtm_product_currency': '',
        'gtm_product_individual_prices': prices,
        'gtm_product_quant': CartJS.cart.item_count,
        'gtm_product_concern': concerns,
        'gtm_skin_type': skin_type,
        'gtm_num_items': numItems
    });

    $('.item__price--sale').css('display', 'inline');

    updateCart();
});


$(".cart__note_container small").on('click', function () {
    $(this).parent().toggleClass('opened').find('textarea').toggleClass('d-none');
})

var addFreeAddon = true;
function updateFreeAddonPrice() {
    if (!ADDON_CAMPAIGN_ACTIVE) return;
    let addonId = ADDON_PRODUCT.id;
    addonId = ADDON_PRODUCT.variants[0].id; // "40125504618543:291d4068779f64d21564595a808c8e17";
    if (addFreeAddon) {
        setTimeout(() => { // delay until it exsists
            if ($(".cart__row[data-id=\"" + addonId + "\"]").length) { // does ADD-ON body sunscreen exist
                // $(".cart__row[data-id=40125504618543] .item__price--aftersale").html('<span rv-html="item.original_price | moneyFormat">FREE</span>');
                $(".cart__row[data-id=\"" + addonId + "\"] .item__price--sale").html(`<span><span rv-html="compare | moneyFormatNoCurrency">${ ADDON_CAMPAIGN_COMPARE_PRICE }</span></span>`);
                // $(".cart__row[data-id=40125504618543] .item__price--sale").show();
                $(".cart__row[data-id=\"" + addonId + "\"] .cart__remove").on('click', function () { // remove free product
                    sessionStorage.setItem('no_free_add-on', true);
                    addFreeAddon = false;
                    sessionStorage.setItem('no_free_add-on', true);
                    var now = new Date();
                    sessionStorage.setItem('no_free_add-on_exp', now.setHours(now.getHours() + 2)); // expire in 2 hours
                    setTimeout(() => {
                        location.reload(); // update price, second item gets price set to FREE
                    }, 300);
                })
            }
        }, 500);
    }
}
updateFreeAddonPrice(); // call on load and on CartJs add
function addOnCampaign() {
    if (ADDON_CAMPAIGN_ACTIVE && CART_JSON.items.length > 0) {
        try { let test = ADDON_PRODUCT.variants[0].id } catch (e) { console.log("Addon product does not exist."); return; }

        var noFreeAddonExp = sessionStorage.getItem('no_free_add-on_exp');
        if (!noFreeAddonExp || noFreeAddonExp < new Date()) {
            sessionStorage.removeItem('no_free_add-on');
            sessionStorage.removeItem('no_free_add-on_exp');
        }
        let refused = sessionStorage.getItem('no_free_add-on') == true;
        var _CART = CartJS.cart.items ? CartJS.cart : CART_JSON;
        let inCart = _CART.items.find(i => i.id == ADDON_PRODUCT.variants[0].id) !== undefined;
        let hasAddOn = _CART.items.filter(i => i.product_type == "Add-on").length > 0;
        var totalPrice = CART_JSON.items_subtotal_price;
        if (typeof CartJS.cart.items_subtotal_price !== "undefined") {
            totalPrice = CartJS.cart.items_subtotal_price;
        }
        
        if (ADDON_CAMPAIGN_SPECIFIC_PRODUCTS != "") {
            // if specific products: only sum totalPrice from those products
            let specificProductHandles = ADDON_CAMPAIGN_SPECIFIC_PRODUCTS.replaceAll(' ', '').split(',');
            let specificProductsInCart = _CART.items.filter(i => specificProductHandles.includes(i.handle));
            totalPrice = specificProductsInCart.map(i => i.price * i.quantity).reduce((partialSum, a) => partialSum + a, 0);
        }

        var addAddon = false;
        if (inCart == false && totalPrice >= ADDON_MIN_CART_TOTAL && refused == false && hasAddOn == false) {
            addAddon = true;
        }
        var removeAddon = false;;
        if (inCart == true) {
            if (totalPrice < ADDON_MIN_CART_TOTAL || refused == true) {
                removeAddon = true;
            }
        }
        // console.log(`addAddon: ${addAddon}, removeAddon: ${removeAddon}, refused: ${refused}, inCart: ${inCart}, hasAddOn: ${hasAddOn}, totalPrice: ${totalPrice}, ADDON_MIN_CART_TOTAL: ${ADDON_MIN_CART_TOTAL}`);
        if (addAddon) {
            CartJS.addItem(ADDON_PRODUCT.variants[0].id, 1, { "_limit": 1 }, {
                "success": function (data, textStatus, jqXHR) {
                    updateFreeAddonPrice();
                },
                "error": function (jqXHR, textStatus, errorThrown) {
                    console.log('CartJS Error.');
                }
            });
        } else if(removeAddon) {
            const line = _CART.items.findIndex(i => i.id == ADDON_PRODUCT.variants[0].id) + 1;
            if (line) { CartJS.removeItem(line); }
        }
    }
}
function removeDuplicateSamples() {
    // console.log('removeDuplicateSamples');
    if (CART_JSON.items.length > 0) {
        var _CART = CartJS.cart.items ? CartJS.cart : CART_JSON;
        const cartSamples = _CART.items.filter(i => i.product_type == 'Sample');
        if (cartSamples.length >= 2) {
            let removeSample = cartSamples[1]; // remove the least recent sample
            const line = item.findIndex(i => i.id == removeSample.variants[0].id) + 1;
            if (line) CartJS.removeItem(line);
            removeDuplicateSamples(); // keep calling until there is 1 sample
        }
    }
}

